(function () {
	const header = () => {
		const body = document.body;
		const header = document.querySelector(".shopify-section-header");
		if (!header) return;

		const headerWrapper = header.querySelector(".header-wrapper");
		const announcementSection = document.querySelector(".section-announcement");

		const headerIsAlwaysSticky =
			headerWrapper?.getAttribute("data-sticky-type") === "always";

		let headerSpacer = document.querySelector(".shopify-header-spacer");
		if (!headerSpacer) {
			headerSpacer = document.createElement("div");
			headerSpacer.className = "shopify-header-spacer";
			header.insertAdjacentElement("afterend", headerSpacer);
		}

		function setSpacerHeight() {
			headerSpacer.style.height = header.classList.contains("is-fixed")
				? `${header.offsetHeight}px`
				: "0px";
		}

		function updateHeaderState() {
			const scrollTop = window.scrollY;

			if (announcementSection) {
				const announcementBottom = announcementSection.getBoundingClientRect().bottom;

				if (announcementBottom <= 0) {
					header.classList.add("is-fixed");
				} else {
					header.classList.remove("is-fixed");
				}
			} else if (headerIsAlwaysSticky && scrollTop > header.offsetHeight) {
				header.classList.add("is-fixed");
			} else {
				header.classList.remove("is-fixed");
			}

			setSpacerHeight();

			const announcementBar = document.querySelector(".announcement-bar");
			const headerOffcanvas = document.querySelector(".burger-drawer");

			if (announcementBar && headerOffcanvas) {
				if (scrollTop > 100) {
					headerOffcanvas.classList.add("announcement-bar-hide");
					headerOffcanvas.classList.remove("announcement-bar-show");
				} else {
					headerOffcanvas.classList.remove("announcement-bar-hide");
					headerOffcanvas.classList.add("announcement-bar-show");
				}
			}
		}

		document.addEventListener("keyup", (e) => {
			if (e.key === "Escape") {
				header.classList.remove(
					"shopify-section-header-sticky",
					"animate",
					"fixed",
					"is-fixed"
				);
				body.classList.remove("overflow-hidden");
				setSpacerHeight();
			}
		});

		let ticking = false;
		window.addEventListener(
			"scroll",
			() => {
				if (!ticking) {
					window.requestAnimationFrame(() => {
						updateHeaderState();
						ticking = false;
					});
					ticking = true;
				}
			},
			{ passive: true }
		);

		window.addEventListener("resize", () => {
			updateHeaderState();
		});

		updateHeaderState();

		$(".header__icon--account").click(function () {
			$(".search-modal").removeClass("active");
		});

		const announcementBar = document.querySelector(".announcement-bar");
		const headerOffcanvas = document.querySelector(".burger-drawer");
		const headerOverlayWithBackground =
			document.querySelector("[data-overlay-with-background]")?.dataset
				.overlayWithBackground === "true";

		if (announcementBar && headerOffcanvas) {
			headerOffcanvas.classList.add("announcement-bar-show");
		}

		$(".shopify-section-header").hover(
			function () {
				if (
					!$(".burger-drawer").hasClass("active") ||
					!$("#search-modal").hasClass("active")
				) {
					if (!headerOverlayWithBackground) {
						$(".shopify-section-header").addClass("color-background-1");
					}
				}
			},
			function () {
				if (
					$(".burger-drawer").hasClass("active") ||
					$("#search-modal").hasClass("active")
				) {
					if (!headerOverlayWithBackground) {
						$(".shopify-section-header").addClass("color-background-1");
					}
				} else {
					$(".shopify-section-header").removeClass("color-background-1");
				}
			}
		);

		let resizeTimeout;

		window.addEventListener("resize", () => {
			clearTimeout(resizeTimeout);
			resizeTimeout = setTimeout(() => {
				const isDesktop = window.innerWidth >= 1150;
				const burgerDrawer = document.querySelector("burger-drawer");

				if (isDesktop) {
					const tabletDrawer = document.querySelector(
						'header-drawer[data-breakpoint="tablet"] details'
					);

					if (tabletDrawer?.hasAttribute("open")) {
						const summary = tabletDrawer.querySelector("summary");
						if (summary) {
							summary.dispatchEvent(new Event("click", { bubbles: true }));
						}
					}
				} else {
					if (burgerDrawer?.classList.contains("active")) {
						burgerDrawer.close();
					}
				}
			}, 300);
		});

		document.addEventListener("click", function (e) {
			if (e.target.closest(".menu-drawer__dropdown-toggle")) {
				e.preventDefault();
				e.stopPropagation();

				const toggle = e.target.closest(".menu-drawer__dropdown-toggle");
				const details = toggle.closest(".menu-drawer__dropdown-details");

				if (details) {
					details.toggleAttribute("open");
				}
			}
		});
	};

	document.addEventListener("shopify:section:load", header);
	header();
})();